import {
  DIVISION_LABELS,
  Division,
  PRICE_TIER_USD,
  RECRUITER_PRICE_RANGE_USD,
  discountedPriceUsd,
  recruiterPriceUsd,
} from '@tnf-recruit/shared'

/** `1200` → `"$1,200"`. Prices are whole dollars, so no cents are shown. */
export function formatUsd(amount: number): string {
  return `$${amount.toLocaleString('en-US')}`
}

/** Annual price for a school, formatted. */
export function formatRecruiterPrice(division: Division | null | undefined): string {
  return formatUsd(recruiterPriceUsd(division))
}

/** A whole-dollar price after taking a percentage off, formatted. */
export function formatDiscountedUsd(amount: number, percentOff: number): string {
  return formatUsd(discountedPriceUsd(amount, percentOff))
}

/** First-year price for a school after the launch discount, formatted. */
export function formatDiscountedRecruiterPrice(
  division: Division | null | undefined,
  percentOff: number
): string {
  return formatDiscountedUsd(recruiterPriceUsd(division), percentOff)
}

export const RECRUITER_PRICE_RANGE_LABEL = `${formatUsd(
  RECRUITER_PRICE_RANGE_USD.min
)}–${formatUsd(RECRUITER_PRICE_RANGE_USD.max)}`

/** The price range with a percentage taken off both ends, formatted. */
export function discountedPriceRangeLabel(percentOff: number): string {
  return `${formatDiscountedUsd(RECRUITER_PRICE_RANGE_USD.min, percentOff)}–${formatDiscountedUsd(
    RECRUITER_PRICE_RANGE_USD.max,
    percentOff
  )}`
}

/** The published rate card, cheapest tier last so the eye lands on the range top. */
export const RECRUITER_TIER_ROWS: Array<{ label: string; usd: number }> = [
  { label: DIVISION_LABELS[Division.NCAA_D1], usd: PRICE_TIER_USD.d1 },
  { label: 'NCAA Division II & NAIA', usd: PRICE_TIER_USD.d2 },
  { label: DIVISION_LABELS[Division.NCAA_D3], usd: PRICE_TIER_USD.d3 },
  { label: 'NJCAA · 3C2A · NWAC · NCCAA · USCAA', usd: PRICE_TIER_USD.juco },
]

/** Shown on every price surface while the intro pricing is in effect. */
export const LIMITED_TIME_PRICING_LABEL = 'Limited-Time Pricing'

export const RENEWAL_DISCLOSURE =
  'Renews yearly at the then-current rate; you will receive a reminder email before it renews.'
